// 분석 LLM 응답 캐시 사용 여부. analyze 호출 시점에 읽혀 useCache로 백엔드에 전달된다.
// 기본은 켜짐(true). 끄면 동일 입력이라도 캐시를 건너뛰고 항상 새로 분석한다.
const LLM_CACHE_LOCAL_STORAGE_KEY = "llm-cache-enabled";

let cachedLlmCacheEnabled: boolean | null = null;

const readLlmCacheEnabled = (): boolean => {
  if (typeof localStorage === "undefined") return true;
  return localStorage.getItem(LLM_CACHE_LOCAL_STORAGE_KEY) !== "false";
};

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === LLM_CACHE_LOCAL_STORAGE_KEY) {
      cachedLlmCacheEnabled = null;
    }
  });
}

export const getLlmCacheEnabled = (): boolean => {
  if (cachedLlmCacheEnabled === null) {
    cachedLlmCacheEnabled = readLlmCacheEnabled();
  }
  return cachedLlmCacheEnabled;
};

export const setLlmCacheEnabled = (enabled: boolean): void => {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(LLM_CACHE_LOCAL_STORAGE_KEY, String(enabled));
  cachedLlmCacheEnabled = enabled;
};
